import AssistantMessageBubble from "./AssistantMessageBubble";
import UserMessageBubble from "./UserMessageBubble";
import type { CsvAttachment, ImageAttachment } from "./types";

export type MessageBubbleProps = {
  messageId?: string;
  role: string;
  content: string;
  images?: ImageAttachment[];
  csvs?: CsvAttachment[];
  sql?: string | null;
  pbiEmbed?: unknown;
  comparison?: unknown;
  tokensInput?: number;
  tokensOutput?: number;
  isStreaming?: boolean;
  onAction?: (action: string) => void;
  agentName?: string;
  createdAt?: string;
  question?: string;
};

export default function MessageBubble({
  messageId,
  role,
  content,
  images,
  csvs,
  sql,
  pbiEmbed,
  comparison,
  tokensInput,
  tokensOutput,
  isStreaming,
  onAction,
  agentName = "AI",
  createdAt,
  question,
}: MessageBubbleProps) {
  if (role === "user") {
    return (
      <UserMessageBubble
        content={content}
        images={images}
        csvs={csvs}
        createdAt={createdAt}
      />
    );
  }

  return (
    <AssistantMessageBubble
      messageId={messageId}
      content={content}
      sql={sql}
      pbiEmbed={pbiEmbed}
      comparison={comparison}
      tokensInput={tokensInput}
      tokensOutput={tokensOutput}
      isStreaming={isStreaming}
      onAction={onAction}
      agentName={agentName}
      createdAt={createdAt}
      question={question}
    />
  );
}
